import { Navigate, useLocation } from 'react-router-dom'
import { useUser } from '../UserContext'
import PropTypes from 'prop-types'
const ProtectedRoute = ({ children, role }) => {
  const { user } = useUser()
  const location = useLocation()
  const from = location.pathname + location.search

  if (role === 'user' && !user.token) {
    return <Navigate to='/sign-in' state={{ from }} />
  }

  if (role === 'admin' && (!user.token || user.userType !== 'admin')) {
    return <Navigate to='/sign-in' state={{ from }} />
  }

  return children
}

export default ProtectedRoute

ProtectedRoute.propTypes = {
  children: PropTypes.element,
  role: PropTypes.string,
}
